import React from 'react';
import Title from '../../title';
import { Grid, Button, Icon, Popup, Dropdown, Pagination, Form, TextArea } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import Loading from '../../loading';
import Type from './filter';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import ReadCookie from '../../../functions/readcookies';

class Accounting extends React.Component {

  state = {
    fromDate: this.getFormatedDate(new Date(), 'fromDate'),
    toDate: this.getFormatedDate(new Date(), 'toDate'), data: [],
    currentpage: 1, boundaryRange: 1, selectedType: '', menuPermission: [],
    siblingRange: 1, showEllipsis: true, showFirstAndLastNav: true, reason: '',
    showPreviousAndNextNav: true, totalPages: 0, overAllOpeningBalance: 0, overAllClosingBalance: 0
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('journal', this.props.menus);
    this.setState({ menuPermission })
  }

  scrollToTop() { window.scrollTo({ top: 0, behavior: "smooth" }); }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month >= 10) ? month : "0" + month;
    date = (date >= 10) ? date : "0" + date;
    let x;
    if (interval == 'fromDate') {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    else {
      x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
  }

  onchangePagenumber = (e, { activePage }) => {
    this.getAccountDetails(activePage);
  }

  getAccountDetails1() {
    this.getAccountDetails(this.state.currentpage);
  }

  getAccountDetails(currentpage) {
    let context = this;
    this.setState({ load: false, message: 'Getting Accounting Details!!!' })
    let selectedType = this.child1.getTypeValue();
    let selectedValue = this.child1.getValue();

    var string = selectedValue; 
    var founded = string.search("->");

    
    let cook = (ReadCookie("vaigai"));
    if (!selectedType || !selectedValue) {
      alert('Select All Details!!!'); return;
    }
    if (this.state.selectedType != selectedType) {
      currentpage = 1;
    }
    
    let data = { 'type': selectedType, 'value': selectedValue, 'currentpage': currentpage,
               'fromDate': this.state.fromDate, 'toDate': this.state.toDate, 'executiveId': cook.id };
    if (founded == 1) {
      data['mode'] = string.split('->')[1];
      data['value'] = 0;
    }
    this.setState({ load: true, message: 'Transferring!!!' });
    $.ajax({
      type: 'POST', data,
      url: Server() + 'accounting/get.php',
      success: function(data) {
        let overAllOpeningBalance = 0;
        let overAllClosingBalance = 0;
        try {
          data = JSON.parse(data);
          data.map((c) => {
            overAllOpeningBalance = c.opening_balance;
            overAllClosingBalance = c.closing_balance;
            data = c.data;
          })
          let totalPages = context.getPageNumber(data);
          totalPages = context.convertToNumber(totalPages);
          context.setState({ overAllOpeningBalance, overAllClosingBalance, selectedType })
          context.closingBalance(data, totalPages, currentpage, selectedType );
        } catch (e) {
          context.setState({ load: false })
          alert('Error to Fetch!!!')
        }
      },
      error: function(e) { context.setState({ load: false }) }
    });
  }

  getPageNumber(data) {
    let page = 0;
    let credit = 0;
    let debit = 0;
    data.map((c) => {
      if (c.type == 'Credit') { credit = c.totalPages; }
      if (c.type == 'Debit') { debit = c.totalPages; }
    })
    page = this.convertToNumber(page);
    credit = this.convertToNumber(credit);
    debit = this.convertToNumber(debit);
    page = credit + debit;
    page = page/100;
    let pageRoundOff = Math.round( page );
    if (pageRoundOff < page) { pageRoundOff++; }
    return pageRoundOff;
  }

  closingBalance(data, totalPages, currentpage) {
    let closing = 0;
    data.sort(function(a,b){
      return new Date(a.timestamp) - new Date(b.timestamp);
    });
    data.map((c) => {

      if (this.child1.getTypeValue() == 'Purchaser') {
        if (c.type == 'Credit') {
          c.closing = this.makeDecimalPoints(this.convertToNumber(closing) + this.convertToNumber(c.amount));
          closing = this.convertToNumber(closing) + this.convertToNumber(c.amount);
        }
        else {
          c.closing = this.makeDecimalPoints(this.convertToNumber(closing) - this.convertToNumber(c.amount));
          closing = this.convertToNumber(closing) - this.convertToNumber(c.amount);
        }
      }
      else if (this.child1.getTypeValue() == 'Ledger') {
        if (c.type == 'Credit') {
          c.closing = this.makeDecimalPoints(this.convertToNumber(closing) - this.convertToNumber(c.amount));
          closing = this.convertToNumber(closing) - this.convertToNumber(c.amount);
        }
        else {
          c.closing = this.makeDecimalPoints(this.convertToNumber(closing) + this.convertToNumber(c.amount));
          closing = this.convertToNumber(closing) + this.convertToNumber(c.amount);
        }
      }
      else {
        if (c.type == 'Credit') {
          c.closing = this.makeDecimalPoints(this.convertToNumber(closing) + this.convertToNumber(c.amount));
          closing = this.convertToNumber(closing) + this.convertToNumber(c.amount);
        }
        else {
          c.closing = this.makeDecimalPoints(this.convertToNumber(closing) - this.convertToNumber(c.amount));
          closing = this.convertToNumber(closing) - this.convertToNumber(c.amount);
        }
      }
    })
    data.sort(function(a,b){
      return new Date(b.timestamp) - new Date(a.timestamp);
    });
    this.setState({ data, totalPages, currentpage, load: false })
  }

  makeDateFormat(value) {
    let date = value.split(' ')[0];
    date = date.split('-')[2]+'-'+date.split('-')[1]+'-'+date.split('-')[0];
    return date;
  }

  makeDecimalPoints(value) {
    try { value = Number(value).toFixed(2); }
    catch (e) { value = 0; }
    return value;
  }

  convertToNumber(value) {
    try { value = Number(value); }
    catch (e) { value = 0; }
    return value;
  }

  cancel(tablename, id) {
    this.setState({ cancelId: id, table_name: tablename, cancelDialog: true })
  }

  handleChange1 = name => event => {
    this.setState({ [name]: event.target.value })
  }

  cancelSubmit() {
    let context = this;
    let { cancelId, table_name, reason } = this.state;
    this.setState({ load: true, message: 'Transferring!!!' });
    $.ajax({
      type: 'POST',
      data: { cancelId, table_name, reason },
      url: Server() + 'accounting/cancel.php',
      success: function(data) {
        if (data == 1) {
          alert('Success');
          context.setState({ cancelId: 0, table_name: '', reason: '', cancelDialog: false, load: false })
        }
        else {
          alert('Try Again!!!');
          context.setState({ load: false })
        }
      },
      error: function(e) { context.setState({ load: false }) }
    });
  }


  render() {
    let totalCreditAmount = 0;
    let totalDebitAmount = 0;
    let selectedType = this.state.selectedType;
    let i = 0;
    let pages = 0;
    let row = (<div></div>);
    row = this.state.data.map((c) => {
      let amount = c.amount;
      if (amount < 0) {
        amount = amount * -1;
      }
      let date = this.makeDateFormat(c.timestamp);
      let creditAmount = this.makeDecimalPoints(amount);
      let debitAmount = this.makeDecimalPoints(amount);
      let voucherno = c.voucherno;
      let type = c.type;
      let mode = c.mode;
      if (this.child1.getTypeValue() == 'Purchaser') {
        if (c.type == 'Purchase') {
          creditAmount = '';
        }
        if (c.type == 'Receipt') {
          creditAmount = '';
        }
        if (c.type == 'Payment') {
          debitAmount = '';
        }
      }
      else if (this.child1.getTypeValue() == 'Ledger') {
        if (c.type == 'Receipt') {
          debitAmount = '';
        }
        if (c.type == 'Payment') {
          creditAmount = '';
        }
        if (c.type == 'Transferfrom') {
          creditAmount = ''; type = 'Transfer';
        }
        if (c.type == 'Transferto') {
          debitAmount = ''; type = 'Transfer';
          
        }
      } 
      else {
        if (c.modetype == 'Credit') {
          if (c.type == 'Receipt') { creditAmount = ''; }
          else { creditAmount = '';  }
        }
        else {
          if (c.type == 'Sales') { debitAmount = ''; }
          else { debitAmount = ''; }
        }
      }
      totalCreditAmount = totalCreditAmount + this.convertToNumber(creditAmount);
      totalDebitAmount = totalDebitAmount + this.convertToNumber(debitAmount);
      return (
        <tbody>
          <Popup trigger={
            <tr>
              <td>{++i}</td>
              <td>{voucherno}</td>
              <td>{type}</td>
              <td>{c.date}</td>
              <td style={{textAlign: 'right'}}>{creditAmount}</td>
              <td style={{textAlign: 'right'}}>{debitAmount}</td>
              <td>{type == 'Transfer Out' || type == 'Transfer In' ? c.customer_name : mode}</td>
              { selectedType == 'Ledger' && this.state.menuPermission.cancel ? 
                <td onClick={this.cancel.bind(this, c.table_name, c.id)}><center><b style={{color: 'red'}}>Cancel</b></center></td> : 
                ''
              }
            </tr>
          } content={<div><b>Remarks:</b>{c.remarks}</div>}
            position='top left' />
        </tbody>
      )
    })
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />

        <Dialog fullWidth={true} maxWidth={'sm'}
          open={this.state.cancelDialog} onClose={ () => { this.setState({ cancelDialog: false }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Reason</DialogTitle>
          <DialogContent>
              Reason<br/>
              <Form>
                <TextArea value={this.state.reason} onChange={this.handleChange1('reason')} fluid />
              </Form>
          </DialogContent>
          <DialogActions>
               <Button onClick={  () => { this.setState({ cancelDialog: false }) } }>Close</Button> 
               <Button onClick={this.cancelSubmit.bind(this)}>Submit</Button> 
          </DialogActions>
        </Dialog>


        <Title title={'Journal'} openDrawer={this.props.openDrawer}/>
        { this.state.menuPermission.view ?
          (
            <div style={{padding: '1%'}} className="scroll-to-top">
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={3}>
                  <b>From Date</b><br/>
                  <input type="date" value={this.state.fromDate} style={{width: '100%', height: 35 }}
                    onChange={ (event) => { this.setState({ fromDate: event.target.value }) }} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={3}>
                  <b>To Date</b><br/>
                  <input type="date" value={this.state.toDate} style={{width: '100%', height: 35 }}
                    onChange={ (event) => { this.setState({ toDate: event.target.value }) }} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Type menuPermission={this.state.menuPermission} transferControl={this.state.transferControl} 
                  ref={instance => { this.child1 = instance; }} getAccountDetails={this.getAccountDetails1.bind(this)} />
                </Grid.Column>
              </Grid>
              <div style={{marginTop: '2px', marginBottom: '2px', display: 'flex'}}>
                <div style={{width: '50%', textAlign: 'left', fontSize: '18px', color: 'blue'}}>{'Opening Balance : '+this.makeDecimalPoints(this.state.overAllOpeningBalance)}</div>
                <div style={{width: '50%', textAlign: 'right', fontSize: '18px', color: 'blue'}}>{'Closing Balance : '+this.makeDecimalPoints(this.state.overAllClosingBalance)}</div>
              </div>
              <table width="100%" id='table'>
                <tr id='tablehead'>
                  <th>Sino</th>
                  <th>Voucher No</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Credit</th>
                  <th>Debit</th>
                  <th>{'O.Ledger'}</th>
                  { selectedType == 'Ledger' && this.state.menuPermission.cancel ? 
                    <th>Cancel</th>:''
                  }
                </tr>
                {row}
                <tr>
                  <td colspan="4"><b>Total</b></td>
                  <td style={{textAlign: 'right'}}><b>Rs. {this.makeDecimalPoints(totalCreditAmount)}</b></td>
                  <td style={{textAlign: 'right'}}><b>Rs. {this.makeDecimalPoints(totalDebitAmount)}</b></td>
                  <td style={{textAlign: 'right'}}><b>Diff. Rs. {this.makeDecimalPoints(totalCreditAmount - totalDebitAmount)}</b></td>
                </tr>
              </table>
              { this.state.data.length > 99 ?
                (
                  <Pagination activePage={this.state.pageNumber} boundaryRange={this.state.boundaryRange}
                    siblingRange={this.state.siblingRange} totalPages={this.state.totalPages}
                    onPageChange={this.onchangePagenumber} ellipsisItem={this.state.showEllipsis ? undefined : null}
                    prevItem={this.state.showPreviousAndNextNav ? undefined : null}
                    nextItem={this.state.showPreviousAndNextNav ? undefined : null}
                  />
                ):
                (<div></div>)
              }

            </div>
          ):
          (
            <center>You Are Not Allow To Access this Menu!!!</center>
          )
        }
      </div>
    );
  }
}

export default Accounting;
